import { literal, object } from 'valibot';

import { GOOGLE_ADS_ACTION_OPEN_PTO_POPUP } from './constants';

export const openPtoPopupSchema = object({
  type: literal(GOOGLE_ADS_ACTION_OPEN_PTO_POPUP),
});
